import $ from 'jquery';

$(function () {
    var modal = $('#modal');
    var openModalButton = $('.openModal');
    var modalContentContainer = $('#modalContentContainer');
    var toggleModal = $('.modalToggle');

    openModalButton.click(function(){
        var modalContent = $(this).find('.modalContent').html();

        modalContentContainer.html(modalContent);
        modal.css('display', 'block');
    });

    toggleModal.click(function(){
        modalContentContainer.html('');
        modal.css('display', 'none');
    })

});



// WEBPACK FOOTER //
// ./resources/assets/js/components/modal.js